import { DecimalPipe } from "@angular/common";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ModalController, Platform, PopoverController } from "ionic-angular";
import { NavParams } from "ionic-angular/navigation/nav-params";
import SortOptions from "models/content-wrapper/sort-options";
import moment from "moment";
import { Observable } from "rxjs/Observable";
import { ISubscription } from "rxjs/Subscription";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";
import { IntercardDataService } from "../intercard-data/intercard-data.service";
import { ResourceManagementService } from "./../../../../providers/resource-management/resource-management.service";

const dateTimeFormat = "MM/DD/YYYY HH:mm";

@Component({
  selector: "hac-expandable-list-card",
  templateUrl: "hac-expandable-list-card.html",
})
export class HacExpandableListCard implements OnInit, OnDestroy {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;
  @Input() visitType: string = "";
  @Input() asmtTypeLookupCode: string;
  @Input() roleLookupCode: string;
  @Input() username: string;

  id: string;
  name: string;
  componentId: string;
  label: string;
  access: string;
  tooltip: object;
  colHeaders: string[];
  conditionalFormatting: object;
  deltaFields: string[];
  // rawData: any[] = [];
  dataRows: any[] = [];
  dummyRow: object;
  prevRow: {};
  declinable: boolean;
  editable: boolean = false;
  manualAdd: boolean = false;
  seeMore: boolean = true;
  seeMoreText: boolean = true;
  seeMoreLength: number = 0;
  moreActions: boolean = false;

  allowExternalData: boolean = false;
  delta: {};

  dataPages: Array<object[]> = [];
  pageSize: number = 5;
  currentPage: number = 0;

  cardDepObs: Observable<any> = null;
  cardDepObsSubscription: ISubscription;

  newConfig;
  resourceData = [];

  patientChartId: string;
  currentWeek: string;
  previousWeek: string;
  currentWeekData: any = [];
  previousWeekData: any = [];
  weekDays: string[] = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];

  constructor(
    public modalCtrl: ModalController,
    public dataService: AssessmentDataService,
    public decimalPipe: DecimalPipe,
    public plt: Platform,
    public translatePipe: TranslateService,
    public intercard: IntercardDataService,
    public popover: PopoverController,
    public resourceManagementService: ResourceManagementService,
    public navParams: NavParams
  ) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.name = this.config.cardName;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined
        ? this.config.label
        : this.config.cardName;
    this.access = this.config.access;
    this.tooltip = this.config.tooltip;
    this.colHeaders = this.config.data.listHeaders;
    this.conditionalFormatting = this.config.data.conditionalFormatting;
    this.deltaFields = this.config.data.deltaFields || [];
    this.declinable = this.config.declinable;
    this.moreActions = this.config.moreActions;
    this.patientChartId = this.navParams.get("patChartId");

    //This new config is checking for duplicates in the dropdown
    this.newConfig = JSON.parse(JSON.stringify(this.config));

    if (this.config.seeMore) {
      this.seeMore = !this.config.seeMore;
      this.seeMoreLength = this.config.seeMoreLength;
    }

    if (this.config.pageSize) {
      this.pageSize = this.config.pageSize;
    }

    if (this.config.addNewBtn === true) {
      this.config.onAddNew = this.onAddNew.bind(this);
    }

    if (this.config.editable) {
      this.editable = this.config.editable;
    }
    if (this.config.manualAdd !== undefined && this.config.manualAdd !== null) {
      this.manualAdd = this.config.manualAdd;
    }
    if (this.config.allowExternalData) {
      this.allowExternalData = this.config.allowExternalData;
    }

    this.dummyRow = { id: "" };
    let dummyData = {};
    for (let header of this.colHeaders) {
      dummyData[header] = "-";
    }
    this.dummyRow["values"] = dummyData;

    if (this.allowExternalData) {
      this.cardDepObs = this.intercard.register(this.name);
      this.cardDepObsSubscription = this.cardDepObs.subscribe((data) => {
        if (data === undefined) {
          return;
        } else if (data["declined"] === true || data["noChanges"] === true) {
          let accept = () => {
            let obj = {};
            if (data["declined"]) {
              obj["acceptedDecline"] = true;
            }
            if (data["noChanges"]) {
              obj["acceptedNoChanges"] = true;
            }
            this.intercard.emitData("declines", obj);
          };

          let reject = () => {
            let obj = {};
            if (data["declined"]) {
              obj["rejectedDeclined"] = true;
            }
            if (data["noChanges"]) {
              obj["rejectedNoChanges"] = true;
            }
            this.intercard.emitData("declines", obj);
          };

          this.presentListForm(
            { category: "patientDeclinedAssessment" },
            accept,
            reject
          );
          return;
        } else if (data["adls"] === true) {
          this.presentListForm({ category: "adlNeeds" });
          return;
        }

        let newData = {};
        for (let header of this.colHeaders) {
          if (data[header]) {
            newData[header] = data[header];
          }
        }
        this.addData(newData);
      });
    }

    if (this.config.hospiceAideCarePlanToggle) {
      this.config.inputs = JSON.parse(JSON.stringify(this.config.inputsToggle));
      this.newConfig.inputs = JSON.parse(
        JSON.stringify(this.config.inputsToggle)
      );
      this.resourceData = this.getResourceManagementData();
    }
  }

  public getResourceManagementData() {
    let array = [];
    this.resourceManagementService
      .getCompanyResourceProvidersAndNonProviders(
        0,
        10000,
        "",
        new SortOptions("last_name", "asc")
      )
      .subscribe((data) => {
        for (let dt of data) {
          for (let content of dt.content) {
            let object = content.firstName + " " + content.lastName;
            array.push(object);
          }
        }
      });
    return array;
  }

  @Input()
  set data(incomingData: any) {
    console.log(incomingData);
    if (incomingData) {
      this.initWeeks();
      this.dataRows = [];
      if (incomingData.data) {
        // this.rawData = incomingData.data;
        for (let data of incomingData.data) {
          let info = {
            id: data.id,
            seemore: this.seeMore,
            seemoretext: this.seeMoreText,
          };
          let values = this.parseDataRow(data);
          info["values"] = values;
          info["rawValues"] = data;
          this.dataRows.push(info);
        }
      }

      this.updateDataPages();

      if (incomingData.previous) {
        let prevData = incomingData.previous;
        let prevInfo = this.parseDataRow(prevData);
        this.prevRow = prevInfo;
        this.prevRow["id"] = prevData.id;
      }
      this.updateDelta();
      this.initWeekDates();
    }
  }

  rowHighlighted(col, value) {
    if (this.conditionalFormatting) {
      let formatting = this.conditionalFormatting[col];
      if (formatting) {
        if (
          formatting.type == "greaterThan" &&
          formatting.refValue !== undefined &&
          value > formatting.refValue
        ) {
          return true;
        }
      }
    }
    return false;
  }

  getPageNumber() {
    return this.currentPage + 1;
  }

  presentListForm(data?: object, accept?: Function, reject?: Function): void {
    let newConfig;
    try {
      newConfig = JSON.parse(JSON.stringify(this.config));
    } catch (e) {
      newConfig = this.config;
    }

    let config = { config: newConfig };

    if (this.config.addNewBtn === true) {
      config.config["onAddNew"] = this.onAddNew.bind(this);
    }

    if (data !== undefined) {
      config["data"] = data;
    }

    let listModal = this.modalCtrl.create("InputModalPage", config, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      if (data !== undefined && data !== null) {
        this.addData(data);
        if (accept) {
          accept();
        }
      } else if (reject) {
        reject();
      }
    });
    listModal.present();
  }

  onAddNew(data: any) {
    this.addData(data);
  }

  updateDelta() {
    if (this.prevRow && this.dataRows[0]) {
      let deltaFields = this.deltaFields;
      let dataRows = this.dataRows;
      let prevRow = this.prevRow;
      this.delta = {};
      for (let header of this.colHeaders) {
        let diff: any = "-";

        if (deltaFields.indexOf(header) == -1) {
          this.delta[header] = diff;
          continue;
        }

        if (header == "date" && moment(dataRows[0].values[header])) {
          let end = moment(dataRows[0].values[header]);
          let start = moment(prevRow[header]);
          let duration = moment.duration(start.diff(end));
          diff = duration.humanize() + " ago";
        } else if (
          !isNaN(dataRows[0].values[header]) &&
          !isNaN(prevRow[header])
        ) {
          diff = dataRows[0].values[header] - prevRow[header];
          diff = parseFloat(this.decimalPipe.transform(diff, "1.0-2"));
          if (diff > 0) {
            diff = "+" + diff;
          }
        }
        this.delta[header] = diff;
      }
    }
  }

  flattenIncomingData(data: object): object {
    let flatData = {};
    for (let key of Object.keys(data)) {
      if (typeof data[key] != "object") {
        flatData[key] = data[key];
      } else {
        let innerObj = data[key];
        if (innerObj == undefined) {
          continue;
        }

        if (key == "frequency") {
          let finalValue = "";
          if (innerObj.numerator) {
            finalValue +=
              innerObj.numerator + this.translatePipe.instant(" time(s) per ");
          }
          if (innerObj.denominator) {
            finalValue += innerObj.denominator + " ";
          }
          if (innerObj.timeUnit) {
            finalValue += this.translatePipe.instant(innerObj.timeUnit);
          }
          flatData[key] = finalValue;
        } else {
          for (let innerKey of Object.keys(innerObj)) {
            if (key == "leftArmOther" || key == "rightArmOther") {
              let newKey = key;
              flatData[newKey] = innerObj[innerKey];
            } else {
              let newKey =
                key + innerKey.replace(/\b\w/g, (l) => l.toUpperCase());
              flatData[newKey] = innerObj[innerKey];
            }
          }
        }
      }
    }
    return flatData;
  }

  parseDataRow(data: any) {
    let values: any = {};
    let flatData = this.flattenIncomingData(data);
    for (let header of this.colHeaders) {
      let val = "-";
      if (flatData[header] || flatData[header] === 0) {
        if (
          header === "date" ||
          header === "reportedOn" ||
          header === "lastReading"
        ) {
          flatData[header] = moment(flatData[header])
            .local()
            .format(dateTimeFormat);
        }
        val = flatData[header];
      }
      values[header] = val;
      values["expanded"] = false;
    }
    if (data.historyId) {
      values["historyId"] = data.historyId;
    }
    return values;
  }

  addData(data: any): void {
    let dt = new Date();
    if (data) {
      if (this.name === "reportableIssues") {
        //check if duplicate reportableIssues
        for (let key of this.dataRows) {
          if (key.values.issueType === data.issueType) {
            return;
          }
        }
      }
      if (this.assessmentId != null) {
        try {
          this.dataService
            .storeRecord(
              this.assessmentId,
              this.sectionId,
              this.id,
              data,
              this.label
            )
            .subscribe((returnData) => {
              if (!returnData) {
                return;
              }
              let newData = {
                id: returnData.id,
                seemore: this.seeMore,
                seemoretext: this.seeMoreText,
              };
              newData["values"] = this.parseDataRow(returnData);

              // this.rawData.unshift(returnData);
              this.dataRows.unshift(newData);
              this.updateDataPages();
              this.updateDelta();
            });
        } catch (error) {}
      }
    }
  }

  editRow(index: number, row: any, isReadonlyInfo: boolean): void {
    this.config = JSON.parse(JSON.stringify(this.config));
    if (this.config.hospiceAideCarePlanToggle) {
      this.config.inputs = JSON.parse(JSON.stringify(this.config.inputsToggle));
    }
    this.config.dataRows = this.dataRows;
    let modalConfig = {
      config: this.config,
      asmtTypeLookupCode: this.asmtTypeLookupCode,
      roleLookupCode: this.roleLookupCode,
      username: this.username,
    };
    // let values = this.rawData.filter(record => record.id == row['id'])[0];
    let values = this.dataRows.filter((record) => record.id == row["id"])[0]
      .rawValues;
    if (values !== null || values !== undefined) {
      let inputKeys = Object.keys(this.config.inputs);
      let editData: any = {};
      for (let key of inputKeys) {
        if (key === "speakWith" && this.config.hospiceAideCarePlanToggle) {
          modalConfig.config.inputs[key].options = this.resourceData;
        }
        if (values[key]) {
          editData[key] = values[key];
        } else {
          editData[key] = null;
        }
      }
      if (isReadonlyInfo) {
        editData.isReadonlyInfo = true;
      }
      modalConfig["data"] = editData;
    }

    let listModal = this.modalCtrl.create("InputModalPage", modalConfig, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      if (data !== undefined) {
        if (this.config.hospiceAideCarePlanToggle) {
          data.historyId = row.values.historyId;
          data.historyKey = moment().format("YYYY-MM-DD");
        }
        data.currentWeek = this.currentWeek;
        this.editData(index, row, row["id"], data);
      }
    });
    listModal.present();
  }

  editData(
    index: number,
    oldRow: any,
    rowId: string,
    data: any,
    caller = "don't care"
  ): void {
    if (data) {
      try {
        this.dataService
          .editRecord(this.assessmentId, this.sectionId, this.id, rowId, data)
          .subscribe((returnData) => {
            let newData = {
              id: returnData.id,
              seemore: this.seeMore,
              seemoretext: this.seeMoreText,
              expanded: oldRow.expanded,
              currentWeekData: oldRow.currentWeekData,
              previousWeekData: oldRow.previousWeekData,
            };
            newData["values"] = this.parseDataRow(returnData);
            newData["rawValues"] = returnData;

            this.dataRows.splice(this.dataRows.indexOf(oldRow), 1, newData);
            this.updateDataPages();
            this.updateDelta();

            if (newData.expanded === true) {
              setTimeout(() => {
                this.getHospiceAideTaskHistory(newData, index);
              }, 1500);
            }
          });
      } catch (error) {
        console.log("Error during data submission and building.", error);
      }
    }
  }

  updateDataPages() {
    this.dataPages = [];

    let dataRows = this.dataRows;
    let pageSize = this.pageSize;
    let dataPages = this.dataPages;
    let pageIndex = -1;
    for (let i = 0; i < dataRows.length; i++) {
      let j = i % pageSize;
      if (j == 0) {
        dataPages.push([]);
        pageIndex++;
      }
      dataPages[pageIndex][j] = dataRows[i];
    }
    if (pageIndex > 0) {
      let endingRow = dataRows.length % pageSize;
      if (endingRow > 0) {
        for (let i = endingRow; i < pageSize; i++) {
          dataPages[pageIndex][i] = this.dummyRow;
        }
      }
    }
    if (this.currentPage > dataRows.length % pageSize) {
      this.prevPage();
    }
  }

  firstPage() {
    if (this.currentPage !== 0) {
      this.currentPage = 0;
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  setPage(page) {
    if (
      page >= 0 &&
      page <= this.dataPages.length &&
      page !== this.currentPage
    ) {
      this.currentPage = page;
    }
  }

  nextPage() {
    if (this.currentPage < this.dataPages.length - 1) {
      this.currentPage++;
    }
  }

  lastPage() {
    if (this.currentPage !== this.dataPages.length - 1) {
      this.currentPage = this.dataPages.length - 1;
    }
  }

  ngOnDestroy() {
    if (this.cardDepObsSubscription) {
      this.cardDepObsSubscription.unsubscribe();
      this.cardDepObs = null;
    }
  }

  viewMore(row, index) {
    row.expanded = !row.expanded;
    if (row.expanded === true && row.values.historyId) {
      this.getHospiceAideTaskHistory(row, index);
    }
  }

  initWeeks() {
    this.currentWeek = `${moment().format("WW")}-${moment().format("YYYY")}`;
    this.previousWeek = `${moment()
      .subtract(1, "weeks")
      .format("WW")}-${moment().format("YYYY")}`;
  }

  initWeekDates() {
    for (var i = 0; i < 7; i++) {
      let pdate: any = {};
      pdate.fullDate = moment()
        .subtract(1, "weeks")
        .day(i)
        .format("YYYY-MM-DD");
      pdate.date = moment().subtract(1, "weeks").day(i).format("DD");
      pdate.day = this.weekDays[i];
      pdate.history = this.fillHistoryData(null);
      this.previousWeekData.push(pdate);

      let cdate: any = {};
      cdate.fullDate = moment().day(i).format("YYYY-MM-DD");
      cdate.date = moment().day(i).format("DD");
      cdate.day = this.weekDays[i];
      cdate.history = this.fillHistoryData(null);
      this.currentWeekData.push(cdate);
    }
    this.dataRows.forEach((dr) => {
      dr.currentWeekData = JSON.parse(JSON.stringify(this.currentWeekData));
      dr.previousWeekData = JSON.parse(JSON.stringify(this.previousWeekData));
    });
  }

  getHospiceAideTaskHistory(row, index) {
    this.dataService
      .getHospiceAideTaskHistory(
        row.values.historyId,
        this.patientChartId,
        this.currentWeek,
        this.previousWeek
      )
      .subscribe((result) => {
        let data: any = result;
        console.log(data);
        if (data != null && data.length > 0) {
          this.formatHospiceAideHistory(data, row, index);
        }
      });
  }

  formatHospiceAideHistory(hospiceAidehistory, row, index) {
    hospiceAidehistory.forEach((history) => {
      if (history.CurrentWeek === true) {
        for (var key of Object.keys(history.HistoryDetails)) {
          this.dataRows[index].currentWeekData.forEach((cw) => {
            if (cw.fullDate === key) {
              cw.history = this.fillHistoryData(row);
              cw.history.completed = history.HistoryDetails[key].Completed;
            }
          });
        }
      } else {
        for (var key of Object.keys(history.HistoryDetails)) {
          this.dataRows[index].previousWeekData.forEach((pw) => {
            if (pw.fullDate === key) {
              pw.history = this.fillHistoryData(row);
              pw.history.completed = history.HistoryDetails[key].Completed;
            }
          });
        }
      }
    });
  }

  fillHistoryData(row) {
    if (row !== null) {
      return {
        completed: "",
        assistance: row.values.assistance,
        category: row.values.category,
        frequency: row.values.frequency,
        haComments: row.values.haComments,
        task: row.values.task,
      };
    } else {
      return {
        completed: "",
        assistance: "",
        category: "",
        frequency: "",
        haComments: "",
        task: "",
      };
    }
  }

  currentDate(day): boolean {
    return day === moment().format("DD");
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/hac-expandable-list-card/hac-expandable-list-card.ts